export const formValues = {
  Name: "Hoppia venue",
  Description: "Venue de hoppia",
  Picture: "https://hoppia.s3-us-west-2.amazonaws.com/events/2020/09/event_hoppia.jpg",
  VenueIndex: "V01",
  Index: 0,
}